

import React from "react"

/**
 * Region North svg icon with defined properties as per UI
 * @returns NorthSvg JSX
 */

export const NorthSvg = () => {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="26" height="26" />
            <path d="M17.5898 12.375V24.3353H15.4057L10.2023 16.8076H10.1147V24.3353H7.58594V12.375H9.80513L14.9677 19.8969H15.0728V12.375H17.5898Z" fill="#717171" />
            <path fillRule="evenodd" clipRule="evenodd" d="M7.82812 10.6074L12.6073 1.07812L17.3283 10.6074L12.6073 8.97548L7.82812 10.6074ZM12.5725 2.9375V7.80414L9.6875 8.67838L12.5725 2.9375Z" fill="#717171" />
        </svg>
    )
}
